
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi et comment utiliser le Pixel Facebook sur vos campagnes",
    description:
      "Apprenez à utiliser le pixel Facebook pour suivre vos KPI comme les conversions, optimiser vos publicités META ADS et atteindre vos objectifs marketing avec ALEO.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
